/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
import {
  Signer,
  utils,
  Contract,
  ContractFactory,
  Overrides,
  BigNumberish,
} from "ethers";
import { Provider, TransactionRequest } from "@ethersproject/providers";
import type {
  SiloCollateralOnly,
  SiloCollateralOnlyInterface,
} from "../SiloCollateralOnly";

const _abi = [
  {
    inputs: [
      {
        internalType: "contract ISiloRepository",
        name: "_repository",
        type: "address",
      },
      {
        internalType: "address",
        name: "_siloAsset",
        type: "address",
      },
      {
        internalType: "uint128",
        name: "_version",
        type: "uint128",
      },
    ],
    stateMutability: "nonpayable",
    type: "constructor",
  },
  {
    inputs: [],
    name: "AssetDoesNotExist",
    type: "error",
  },
  {
    inputs: [],
    name: "BorrowNotPossible",
    type: "error",
  },
  {
    inputs: [],
    name: "DepositNotPossible",
    type: "error",
  },
  {
    inputs: [],
    name: "DepositsExceedLimit",
    type: "error",
  },
  {
    inputs: [],
    name: "DifferentArrayLength",
    type: "error",
  },
  {
    inputs: [],
    name: "InvalidRepository",
    type: "error",
  },
  {
    inputs: [],
    name: "InvalidSiloVersion",
    type: "error",
  },
  {
    inputs: [],
    name: "LiquidationReentrancyCall",
    type: "error",
  },
  {
    inputs: [],
    name: "MaximumLTVReached",
    type: "error",
  },
  {
    inputs: [],
    name: "NotEnoughDeposits",
    type: "error",
  },
  {
    inputs: [],
    name: "NotEnoughLiquidity",
    type: "error",
  },
  {
    inputs: [],
    name: "NotSolvent",
    type: "error",
  },
  {
    inputs: [],
    name: "OnlyRouter",
    type: "error",
  },
  {
    inputs: [],
    name: "Paused",
    type: "error",
  },
  {
    inputs: [],
    name: "SiloAssetIsCollateralOnly",
    type: "error",
  },
  {
    inputs: [],
    name: "TokenIsNotAContract",
    type: "error",
  },
  {
    inputs: [],
    name: "UnexpectedEmptyReturn",
    type: "error",
  },
  {
    inputs: [],
    name: "UnsupportedLTVType",
    type: "error",
  },
  {
    inputs: [],
    name: "UserIsZero",
    type: "error",
  },
  {
    inputs: [],
    name: "ZeroAssets",
    type: "error",
  },
  {
    inputs: [],
    name: "ZeroShares",
    type: "error",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "asset",
        type: "address",
      },
      {
        indexed: true,
        internalType: "enum IBaseSilo.AssetStatus",
        name: "status",
        type: "uint8",
      },
    ],
    name: "AssetStatusUpdate",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "asset",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "user",
        type: "address",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "amount",
        type: "uint256",
      },
    ],
    name: "Borrow",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "asset",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "depositor",
        type: "address",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "amount",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "bool",
        name: "collateralOnly",
        type: "bool",
      },
    ],
    name: "Deposit",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "asset",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "user",
        type: "address",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "shareAmountRepaid",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "seizedCollateral",
        type: "uint256",
      },
    ],
    name: "Liquidate",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "asset",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "user",
        type: "address",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "amount",
        type: "uint256",
      },
    ],
    name: "Repay",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "asset",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "depositor",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "receiver",
        type: "address",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "amount",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "bool",
        name: "collateralOnly",
        type: "bool",
      },
    ],
    name: "Withdraw",
    type: "event",
  },
  {
    inputs: [],
    name: "VERSION",
    outputs: [
      {
        internalType: "uint128",
        name: "",
        type: "uint128",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_asset",
        type: "address",
      },
    ],
    name: "accrueInterest",
    outputs: [
      {
        internalType: "uint256",
        name: "interest",
        type: "uint256",
      },
    ],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_asset",
        type: "address",
      },
    ],
    name: "assetStorage",
    outputs: [
      {
        components: [
          {
            internalType: "contract IShareToken",
            name: "collateralToken",
            type: "address",
          },
          {
            internalType: "contract IShareToken",
            name: "collateralOnlyToken",
            type: "address",
          },
          {
            internalType: "contract IShareToken",
            name: "debtToken",
            type: "address",
          },
          {
            internalType: "uint256",
            name: "totalDeposits",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "collateralOnlyDeposits",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "totalBorrowAmount",
            type: "uint256",
          },
        ],
        internalType: "struct IBaseSilo.AssetStorage",
        name: "",
        type: "tuple",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_asset",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "_amount",
        type: "uint256",
      },
    ],
    name: "borrow",
    outputs: [
      {
        internalType: "uint256",
        name: "debtAmount",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "debtShare",
        type: "uint256",
      },
    ],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_asset",
        type: "address",
      },
      {
        internalType: "address",
        name: "_borrower",
        type: "address",
      },
      {
        internalType: "address",
        name: "_receiver",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "_amount",
        type: "uint256",
      },
    ],
    name: "borrowFor",
    outputs: [
      {
        internalType: "uint256",
        name: "debtAmount",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "debtShare",
        type: "uint256",
      },
    ],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_asset",
        type: "address",
      },
      {
        internalType: "address",
        name: "_borrower",
        type: "address",
      },
    ],
    name: "borrowPossible",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_asset",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "_amount",
        type: "uint256",
      },
      {
        internalType: "bool",
        name: "_collateralOnly",
        type: "bool",
      },
    ],
    name: "deposit",
    outputs: [
      {
        internalType: "uint256",
        name: "collateralAmount",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "collateralShare",
        type: "uint256",
      },
    ],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_asset",
        type: "address",
      },
      {
        internalType: "address",
        name: "_depositor",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "_amount",
        type: "uint256",
      },
      {
        internalType: "bool",
        name: "_collateralOnly",
        type: "bool",
      },
    ],
    name: "depositFor",
    outputs: [
      {
        internalType: "uint256",
        name: "collateralAmount",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "collateralShare",
        type: "uint256",
      },
    ],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_asset",
        type: "address",
      },
      {
        internalType: "address",
        name: "_depositor",
        type: "address",
      },
    ],
    name: "depositPossible",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address[]",
        name: "_users",
        type: "address[]",
      },
      {
        internalType: "bytes",
        name: "_flashReceiverData",
        type: "bytes",
      },
    ],
    name: "flashLiquidate",
    outputs: [
      {
        internalType: "address[]",
        name: "assets",
        type: "address[]",
      },
      {
        internalType: "uint256[][]",
        name: "receivedCollaterals",
        type: "uint256[][]",
      },
      {
        internalType: "uint256[][]",
        name: "shareAmountsToRepay",
        type: "uint256[][]",
      },
    ],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "getAssets",
    outputs: [
      {
        internalType: "address[]",
        name: "assets",
        type: "address[]",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "getAssetsWithState",
    outputs: [
      {
        internalType: "address[]",
        name: "assets",
        type: "address[]",
      },
      {
        components: [
          {
            internalType: "contract IShareToken",
            name: "collateralToken",
            type: "address",
          },
          {
            internalType: "contract IShareToken",
            name: "collateralOnlyToken",
            type: "address",
          },
          {
            internalType: "contract IShareToken",
            name: "debtToken",
            type: "address",
          },
          {
            internalType: "uint256",
            name: "totalDeposits",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "collateralOnlyDeposits",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "totalBorrowAmount",
            type: "uint256",
          },
        ],
        internalType: "struct IBaseSilo.AssetStorage[]",
        name: "assetsStorage",
        type: "tuple[]",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "harvestProtocolFees",
    outputs: [
      {
        internalType: "uint256[]",
        name: "harvestedAmounts",
        type: "uint256[]",
      },
    ],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "initAssetsTokens",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_asset",
        type: "address",
      },
    ],
    name: "interestData",
    outputs: [
      {
        components: [
          {
            internalType: "uint256",
            name: "harvestedProtocolFees",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "protocolFees",
            type: "uint256",
          },
          {
            internalType: "uint64",
            name: "interestRateTimestamp",
            type: "uint64",
          },
          {
            internalType: "enum IBaseSilo.AssetStatus",
            name: "status",
            type: "uint8",
          },
        ],
        internalType: "struct IBaseSilo.AssetInterestData",
        name: "",
        type: "tuple",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_user",
        type: "address",
      },
    ],
    name: "isSolvent",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_asset",
        type: "address",
      },
    ],
    name: "liquidity",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_asset",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "_amount",
        type: "uint256",
      },
    ],
    name: "repay",
    outputs: [
      {
        internalType: "uint256",
        name: "repaidAmount",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "repaidShare",
        type: "uint256",
      },
    ],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_asset",
        type: "address",
      },
      {
        internalType: "address",
        name: "_borrower",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "_amount",
        type: "uint256",
      },
    ],
    name: "repayFor",
    outputs: [
      {
        internalType: "uint256",
        name: "repaidAmount",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "repaidShare",
        type: "uint256",
      },
    ],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "siloAsset",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "siloRepository",
    outputs: [
      {
        internalType: "contract ISiloRepository",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "syncBridgeAssets",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_asset",
        type: "address",
      },
    ],
    name: "utilizationData",
    outputs: [
      {
        components: [
          {
            internalType: "uint256",
            name: "totalDeposits",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "totalBorrowAmount",
            type: "uint256",
          },
          {
            internalType: "uint64",
            name: "interestRateTimestamp",
            type: "uint64",
          },
        ],
        internalType: "struct IBaseSilo.UtilizationData",
        name: "data",
        type: "tuple",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_asset",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "_amount",
        type: "uint256",
      },
      {
        internalType: "bool",
        name: "_collateralOnly",
        type: "bool",
      },
    ],
    name: "withdraw",
    outputs: [
      {
        internalType: "uint256",
        name: "withdrawnAmount",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "withdrawnShare",
        type: "uint256",
      },
    ],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_asset",
        type: "address",
      },
      {
        internalType: "address",
        name: "_depositor",
        type: "address",
      },
      {
        internalType: "address",
        name: "_receiver",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "_amount",
        type: "uint256",
      },
      {
        internalType: "bool",
        name: "_collateralOnly",
        type: "bool",
      },
    ],
    name: "withdrawFor",
    outputs: [
      {
        internalType: "uint256",
        name: "withdrawnAmount",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "withdrawnShare",
        type: "uint256",
      },
    ],
    stateMutability: "nonpayable",
    type: "function",
  },
];

const _bytecode =
  "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";

type SiloCollateralOnlyConstructorParams =
  | [signer?: Signer]
  | ConstructorParameters<typeof ContractFactory>;

const isSuperArgs = (
  xs: SiloCollateralOnlyConstructorParams
): xs is ConstructorParameters<typeof ContractFactory> => xs.length > 1;

export class SiloCollateralOnly__factory extends ContractFactory {
  constructor(...args: SiloCollateralOnlyConstructorParams) {
    if (isSuperArgs(args)) {
      super(...args);
    } else {
      super(_abi, _bytecode, args[0]);
    }
    this.contractName = "SiloCollateralOnly";
  }

  deploy(
    _repository: string,
    _siloAsset: string,
    _version: BigNumberish,
    overrides?: Overrides & { from?: string | Promise<string> }
  ): Promise<SiloCollateralOnly> {
    return super.deploy(
      _repository,
      _siloAsset,
      _version,
      overrides || {}
    ) as Promise<SiloCollateralOnly>;
  }
  getDeployTransaction(
    _repository: string,
    _siloAsset: string,
    _version: BigNumberish,
    overrides?: Overrides & { from?: string | Promise<string> }
  ): TransactionRequest {
    return super.getDeployTransaction(
      _repository,
      _siloAsset,
      _version,
      overrides || {}
    );
  }
  attach(address: string): SiloCollateralOnly {
    return super.attach(address) as SiloCollateralOnly;
  }
  connect(signer: Signer): SiloCollateralOnly__factory {
    return super.connect(signer) as SiloCollateralOnly__factory;
  }
  static readonly contractName: "SiloCollateralOnly";
  public readonly contractName: "SiloCollateralOnly";
  static readonly bytecode = _bytecode;
  static readonly abi = _abi;
  static createInterface(): SiloCollateralOnlyInterface {
    return new utils.Interface(_abi) as SiloCollateralOnlyInterface;
  }
  static connect(
    address: string,
    signerOrProvider: Signer | Provider
  ): SiloCollateralOnly {
    return new Contract(address, _abi, signerOrProvider) as SiloCollateralOnly;
  }
}
